var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: ".817em",
    height: "1em",
    viewBox: "0 0 14.295 17.472"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 94665"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M13.952 8.289a1.15 1.15 0 0 0-.844-.347h-.4V5.559a5.35 5.35 0 0 0-1.638-3.921 5.51 5.51 0 0 0-7.842 0A5.35 5.35 0 0 0 1.59 5.559v2.383h-.4A1.186 1.186 0 0 0-.001 9.133v7.147a1.186 1.186 0 0 0 1.191 1.191h11.913a1.186 1.186 0 0 0 1.191-1.191V9.133a1.15 1.15 0 0 0-.342-.844m-3.623-.347H3.971V5.559a3.06 3.06 0 0 1 .931-2.246 3.176 3.176 0 0 1 4.492 0 3.06 3.06 0 0 1 .93 2.246Z",
    "data-name": "Path 60123"
  }))));
};
export default SvgLock;